module.exports = __webpack_public_path__ + "static/media/blog-launching-distilled-id@2x.b30ca684.jpg";